import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import { useParams } from 'react-router-dom'
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import config from "../../config.json"
import useAuth from "../../core/Authentication/useAuth"

export default function LogInWithPinPage() {
    const { pin } = useParams()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true)
    const auth = useAuth()

    useEffect(() => {
        if (pin.length < 8) {
            navigate("/login")
        }
        else {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Cache-Control", "no-cache");

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify({
                    "pin": pin
                }),
            }

            setIsLoading(true)

            fetch(config.baseUrl + "login_by_pin", requestOptions)
                .then(response => response.json())
                .then(
                    (result) => {
                        if (result.hasOwnProperty("token")) {
                            auth.login(result)
                            navigate("/profile")
                        }
                        else {
                            navigate("/login")
                        }
                    },
                    (error) => {
                        console.log(error)
                        navigate("/login")
                    }
                )
        }
    }, [pin])

    return (
        <TMHBanner isLogged={false}>
            {isLoading && <TMHLoader />}
        </TMHBanner>
    )
}
